// Insight.js
import Style from "./Insight.module.css";

const Insight = () => {
  return (
    <div className={Style.InsightContainerMain}>
      <div className={Style.InsightContainer}>
      </div>
      <div className={Style.InsightContainerFortext}>
      <h1 className={Style.InsightText}>Launching on April 5th.</h1>
      </div>
    </div>
  );
};

export default Insight; 